import React from "react";
import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";

export default function PageHero({
  eyebrow,
  title,
  subtitle,
  image,
  imageAlt = "",
  children,
  compact = false,
}) {
  return (
    <section className="relative overflow-hidden bg-navy text-white">
      <div className="absolute inset-0 hero-grid opacity-25" />
      <div className="absolute -top-40 -left-32 h-[430px] w-[430px] rounded-full bg-redcanada/20 blur-[120px]" />
      <div className="absolute -bottom-48 right-0 h-[520px] w-[520px] rounded-full bg-gold/10 blur-[130px]" />

      <div className={`relative max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-10 items-center ${compact ? "py-14 lg:py-16" : "py-16 lg:py-24"}`}>
        <div className={image ? "lg:col-span-7" : "lg:col-span-9"}>
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            className="inline-flex items-center gap-2 rounded-full border border-gold/35 bg-white/5 px-4 py-2 text-[10px] sm:text-xs uppercase tracking-[0.22em] text-gold-light"
          >
            <Sparkles size={13} /> {eyebrow}
          </motion.div>
          <motion.h1
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.08, duration: 0.65 }}
            className="mt-6 font-serif text-5xl sm:text-6xl lg:text-7xl xl:text-[82px] leading-[0.94] tracking-[-0.035em]"
          >
            {title}
          </motion.h1>
          {subtitle && (
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.2 }}
              className="mt-6 max-w-2xl text-base sm:text-lg leading-relaxed text-white/68"
            >
              {subtitle}
            </motion.p>
          )}
          {children && <div className="mt-7">{children}</div>}
        </div>

        {image && (
          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.15, duration: 0.7 }}
            className="lg:col-span-5"
          >
            <div className="relative aspect-[4/3] overflow-hidden rounded-[2rem] border border-white/12 shadow-2xl">
              <img src={image} alt={imageAlt} className="h-full w-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy/65 via-transparent to-transparent" />
              <div className="absolute left-5 bottom-5 rounded-full border border-white/15 bg-navy/65 px-4 py-2 text-xs tracking-[0.16em] uppercase text-white/80 backdrop-blur-md">
                JN Immigration Consulting
              </div>
            </div>
          </motion.div>
        )}
      </div>
    </section>
  );
}
